module.exports = __webpack_public_path__ + "static/37-8728a4a187ad3f56ff98c0f1026b9254.png";